import PropTypes from "prop-types";
import faktObsahPropTypes from "./faktObsahPropTypes";

const propTypes = {
  faktura: PropTypes.shape({
    I_ZIS_FAKT_HL: PropTypes.number,
    I_ZMLUVY: PropTypes.number,
    I_ORGAN: PropTypes.number,
    C_FAKTURY: PropTypes.string,
    D_VYSTAVENIA: PropTypes.instanceOf(Date),
    D_SPLATNOSTI: PropTypes.instanceOf(Date),
    L_BD: PropTypes.number,
    SUMA_FAKTURY: PropTypes.string,
    FaktObsahy: PropTypes.arrayOf(faktObsahPropTypes.faktObsah),
  }),
};

export default propTypes;
